export default __webpack_public_path__ + "static/media/ag-icon.fabd715c.webp";